module.exports = __webpack_public_path__ + "static/media/git.08ec5722.png";